export default "__VITE_ASSET__CJtrkjel__"